export interface FilterConfigurationValidationResult {
  isValid: boolean;
  errorMessage: string;
}

export const buildValidationResult = (isValid: boolean, errorMessage: string): FilterConfigurationValidationResult => {
  return {
    isValid: isValid,
    errorMessage: errorMessage
  };
};
